import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import RowClick from '../../../../common/RowClick';
import Table from '../../../../common/table/Table';
import TextBlink from '../../../../common/table/TextBlink';
import { getColorPrice } from '../../../../helpers/Color';
import { getDataFollowKeyByDot, getRanking } from '../../../../helpers/Common';
import {
  formatPrice,
  formatTextFloat,
  formatVolume,
} from '../../../../helpers/Text';
import CellHover from '../../../../market/watchlist/summary/CellHover';
import '../../../technical.scss';
import { REDUCER_NAME } from '../reducer';
import Const from './Const';
import { I18n } from 'react-redux-i18n';
import { compose } from 'redux';
import TradingViewUrl from '../../../../common/TradingViewUrl';

class TableAbnormality extends React.PureComponent {
  getDataFromRedux = state =>
    state[REDUCER_NAME].listObjectDeceptiveAbnormalityDataByTicker;

  getClassName = (item, listColumn) => {
    return getColorPrice(
      getDataFollowKeyByDot(item, listColumn.PRICE),
      getDataFollowKeyByDot(item, listColumn.REF_PRICE),
      getDataFollowKeyByDot(item, listColumn.HIGH_PRICE),
      getDataFollowKeyByDot(item, listColumn.LOW_PRICE),
      'text',
    );
  };

  handleScroll = e => {
    const { totalPage, page } = this.props;
    const bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;
    if (page >= totalPage) return;
    if (bottom) {
      const { onLoadMore } = this.props;
      onLoadMore(page + 1);
    }
  };

  schema = (listColumn, i18nTitleKey) =>
    Object.keys(Const.listColumn).map((item, index) => {
      const key = listColumn[item];
      const title = `${i18nTitleKey}.${item}`;

      const result = {
        key,
        title,
      };

      if (index === 0) {
        return {
          ...result,
          isString: true,
          thStyle: { width: '40px' },
          render: (text, item) => (
            <CellHover organCode={item.organCode} isShowDeleteIcon={false}>
              <TextBlink item={item} tradingDate="tradingDate">
                <TradingViewUrl code={item.organCode} />
                &nbsp;{text}
              </TextBlink>
            </CellHover>
          ),
        };
      }

      if (_.includes([listColumn.PRICE], key)) {
        return {
          ...result,
          render: (text, item) => {
            const className = this.getClassName(item, listColumn);
            return (
              <TextBlink
                item={item}
                tradingDate="tradingDate"
                className={className}
              >
                {formatTextFloat(formatPrice(text))}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.VOLUME, listColumn.AVG_VOLUME], key)) {
        return {
          ...result,
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(formatVolume(text))}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.RATIO], key)) {
        return {
          ...result,
          thTooltip: I18n.t('table.technical.ratio'),
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(text)}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.PREV_SESSION], key)) {
        return {
          ...result,
          thTooltip: I18n.t('table.technical.sessionPrev'),
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                <span>{text}</span>
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.SESSION], key)) {
        return {
          ...result,
          thTooltip: I18n.t('table.technical.session'),
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {text}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.VOLUME_CE_FL_UNMATCHED], key)) {
        const valueFromItem = item => {
          const { filterData } = this.props;
          const abnormalityType = filterData[2].filterLineOne;
          return abnormalityType === 1
            ? getDataFollowKeyByDot(item, Const.listColumn.VOLUME_CE_UNMATCHED)
            : getDataFollowKeyByDot(item, Const.listColumn.VOLUME_FL_UNMATCHED);
        };

        return {
          ...result,
          valueFromItem,
          render: (text, item) => {
            const cefl = valueFromItem(item);
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                <span>{formatTextFloat(formatVolume(cefl))}</span>
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.RANK], key)) {
        return {
          ...result,
          thTooltip: I18n.t('table.technical.ranking'),
          render: (text, item) => {
            const total = getDataFollowKeyByDot(
              item,
              Const.listColumn.TOTALRANK,
            );
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {getRanking(text, total)}
              </TextBlink>
            );
          },
        };
      }

      return {
        ...result,
        render: text => text,
      };
    });

  render() {
    const { isLoading, onSort, ids, scrollRef } = this.props;
    if (ids.length === 0 && !isLoading) {
      return (
        <div className="empty-data-msg text-s-color-3">
          {I18n.t('tasignals.deceptiveDataMessage.noDataForFilter')}
        </div>
      );
    }
    return (
      <RowClick>
        {onRowClick => (
          <Table
            onSort={onSort}
            clickRow={onRowClick}
            thValign="top"
            isLoading={isLoading}
            ids={ids}
            scrollRef={scrollRef}
            resizable={true}
            columnDraggable={false}
            onScrollFunction={this.handleScroll}
            rowDraggable={false}
            hideColumns={Const.listHideColumn}
            getDataFromRedux={this.getDataFromRedux}
            isShowHeadLoading={true}
            schema={this.schema(
              Const.listColumn,
              'tasignals.ceflAbnormalityHeader',
            )}
          />
        )}
      </RowClick>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    ids: state[REDUCER_NAME].listDeceptiveAbnormalityDataTicker,
    isLoading: state[REDUCER_NAME].isLoading,
    totalPage: state[REDUCER_NAME].totalPage,
    filterData: state[REDUCER_NAME].filterData,
  };
};

const enhance = compose(connect(mapStateToProps));

export default enhance(TableAbnormality);
